export default {
	title: "Create some key results for your goal.",
	description1: "Key results are the measurable steps needed to accomplish your goal. Put another way, if the goal states where you want to go, the key results are how you’ll get there.",
	description2: "If you’re not yet ready to create your key results, you can come back later to fill them in.",
	newKeyResultButtonText: "New key result",
};
